export enum ReservationCategory {
  INCOMPLETE = 'incomplete',
  CLAIMED = 'claimed',
  PAST = 'past',
}
